<template>
  <div class="map-contanier">
    <div id="map-full"></div>
    <!-- Cover Date -->
    <div class="title-card" v-if="dataTimeline[0]">
      <v-col class="column-container title-web">
        <!-- v-bind:style="{ backgroundImage: 'url(./banner_web_dark.jpg)' }" -->
        <v-card
          color="#fff"
          style="width: 100%; height: 100%"
          v-bind:style="{ backgroundImage: 'url(./banner_web_dark.jpg)' }"
          dark
        >
          <div class="title-area-container">
            <a target="_blank" href="https://covid19.longdo.com"
              style="color: #fff; text-decoration: none;display: flex; flex-direction: column; align-items: flex-end; padding:10px 10px 10px 0px;"
            >
              <div style="font-size: 0.9em;">สถานการณ์ผู้ติดเชื้อ</div>
              <div style="font-size: 1.1em; color:#ef0400; font-weight:bold;">
                <span class="yellow-font">ไวรัส</span> COVID-19
              </div>
              <div style="font-size: 0.9em;" v-show="toggle_type === 0">ทั้งหมดในประเทศไทย</div>
              <div style="font-size: 0.9em;" v-show="toggle_type === 1">ทั้งหมดของโลก</div>
              <span
                v-show="toggle_type === 0"
                style="font-size: 0.8em; color:rgb(191, 191, 191);"
              >{{ convertDate(dataTimeline[slider].Date) }}</span>
              <span
                v-show="toggle_type === 1 && worldCaseData !== undefined"
                style="font-size: 0.8em; color:rgb(191, 191, 191);"
              >{{ convertDateWorldData(worldCaseData.lastUpdated) }}</span>
              <!-- <span
                v-show="toggle_type === 1"
                v-if="worldCaseData.lastUpdated"
                style="font-size: 0.8em; color:rgb(191, 191, 191);"
              >{{ worldCaseData.lastUpdated }}</span> -->
            </a>
          </div>
        </v-card>
      </v-col>
    </div>

    <!-- Stats Card -->
    <div class="stats-card" v-show="toggle_type === 0">
      <v-col
        class="column-container pa-1 align-self-center"
        cols="12"
        v-if="seriesThailandGraph[0]"
      >
        <div class="d-flex flex-column">
          <div class="d-flex first-stats-card">
            <v-card class="ma-1 report-header" color="#5EAAFFE6">
              <div class="report-title">ผู้ติดเชื้อสะสม</div>
              <div class="report-number">{{numberWithCommas(seriesThailandGraph[0].data[slider].y)}}</div>
              <div class="added-number-report">{{adjustNewCase(dataTimeline[slider].NewConfirmed)}}</div>
            </v-card>
          </div>
          <div class="d-flex second-stats-card">
            <v-card class="ma-1 report-header" color="#FFC431E6">
              <div class="report-title">กำลังรักษา</div>
              <div
                class="report-number-sub"
              >{{numberWithCommas(seriesThailandGraph[1].data[slider].y)}}</div>
              <div
                class="added-number-report"
              >{{adjustNewCase(dataTimeline[slider].NewHospitalized)}}</div>
            </v-card>
            <v-card class="ma-1 report-header" color="#4BC09EE6">
              <div class="report-title">หายแล้ว</div>
              <div
                class="report-number-sub"
              >{{numberWithCommas(seriesThailandGraph[2].data[slider].y)}}</div>
              <div class="added-number-report">{{adjustNewCase(dataTimeline[slider].NewRecovered)}}</div>
            </v-card>
            <v-card class="ma-1 report-header" color="#F14554E6">
              <div class="report-title">เสียชีวิต</div>
              <div
                class="report-number-sub"
              >{{numberWithCommas(seriesThailandGraph[3].data[slider].y)}}</div>
              <div class="added-number-report">{{adjustNewCase(dataTimeline[slider].NewDeaths)}}</div>
            </v-card>
          </div>
        </div>
      </v-col>
    </div>

    <!-- for world -->
    <div class="stats-card" v-show="toggle_type === 1">
      <v-col
        class="column-container pa-1 align-self-center"
        cols="12"
        v-if="worldCaseData !== undefined"
      >
        <div class="d-flex flex-column">
          <div class="d-flex first-stats-card">
            <v-card
              class="ma-1 report-header pointer confirmed-stats"
              color="#5EAAFFE6"
              style="width: 100%;"
              @click="toggle_type_case = 0"
            >
              <div class="report-title">ผู้ติดเชื้อสะสม</div>
              <div class="report-number">{{numberWithCommas(worldCaseData.totalConfirmed)}}</div>
              <!-- <div class="added-number-report">ราย</div> -->
            </v-card>
          </div>
          <div class="d-flex second-stats-card">
            <v-card
              class="ma-1 report-header pointer"
              color="#4BC09EE6"
              style="width: 100%;"
              @click="toggle_type_case = 1"
            >
              <div class="report-title">หายแล้ว</div>
              <div class="report-number-sub">{{numberWithCommas(worldCaseData.totalRecovered)}}</div>
              <!-- <div class="added-number-report">ราย</div> -->
            </v-card>
            <v-card
              class="ma-1 report-header pointer"
              color="#F14554E6"
              style="width: 100%;"
              @click="toggle_type_case = 2"
            >
              <div class="report-title">เสียชีวิต</div>
              <div class="report-number-sub">{{numberWithCommas(worldCaseData.totalDeaths)}}</div>
              <!-- <div class="added-number-report">ราย</div> -->
            </v-card>
          </div>
        </div>
      </v-col>
    </div>

    <div
      class="text-center toggle-world-table"
      v-bind:class="{ active: showNav }"
      v-show="toggle_type === 1"
    >
      <v-btn color="white" @click="showNav = !showNav">{{ buttonWorldList }}</v-btn>
    </div>

    <v-data-table
      v-show="toggle_type === 1 && showNav === true"
      :headers="worldTableHeaders"
      :items="worldTableContent"
      :items-per-page="worldTableContent.length"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      class="world-table-reported"
      :mobile-breakpoint="NaN"
    >
      <template v-slot:item="{ item, index }">
        <tr @click="clickCountryTable(item.alpha2)" class="tr-country-table">
          <td style="padding: 5px;">{{ index + 1 }}</td>
          <td class="text-start">
            <img
              class="flag-icon"
              :src="`${publicPath}./flags/`+ item.alpha2.toLowerCase() +`.png`"
            />
            {{ item.name }}
          </td>
          <td class="text-end">{{ numberWithCommas(item.confirmed) }}</td>
          <td class="text-end">{{ numberWithCommas(item.recovered) }}</td>
          <td class="text-end">{{ numberWithCommas(item.deaths) }}</td>
        </tr>
      </template>
      <!-- <template v-slot:item.name="{ item }">
        <img class="flag-icon" :src="`${publicPath}./flags/`+ item.alpha2.toLowerCase() +`.png`" />
        {{ item.name }}
      </template>
      <template v-slot:item.confirmed="{ item }">{{ numberWithCommas(item.confirmed) }}</template>
      <template v-slot:item.recovered="{ item }">{{ numberWithCommas(item.recovered) }}</template>
      <template v-slot:item.deaths="{ item }">{{ numberWithCommas(item.deaths) }}</template>-->
    </v-data-table>

    <!-- tab ด้านล่าง -->
    <v-tabs
      class="information-container"
      vertical
      show-arrows
      background-color
      dark
      slider-color="white"
      v-model="tabs"
      v-show="toggle_type === 0"
    >
      <v-tab ripple>ภาพรวม</v-tab>
      <v-tab ripple>ผู้ป่วยใหม่</v-tab>
      <!-- <v-tab ripple>ทั้งประเทศ</v-tab> -->
      <v-tab ripple>จังหวัดติดเชื้อ</v-tab>
      <v-tabs-items class="thailandChart" dark v-model="tabs">
        <v-tab-item>
          <apexchart
            type="line"
            height="100%"
            :options="thailandChartOptions"
            :series="seriesThailandGraph"
          ></apexchart>
        </v-tab-item>
        <v-tab-item>
          <apexchart
            type="line"
            height="100%"
            :options="newCaseChartOptions"
            :series="newCaseChartSeries"
          ></apexchart>
        </v-tab-item>
        <!-- <v-tab-item>
          <apexchart
            type="bar"
            height="400px"
            :options="provinceBarChartOptions"
            :series="provinceCaseSeries"
          ></apexchart>
        </v-tab-item>-->
        <v-tab-item style="min-height: 350px;">
          <v-data-table
            :headers="provinceTimelineHeader"
            :items="provinceTimelineItems"
            :items-per-page="provinceTimelineItems.length"
            class="elevation-1"
            :sort-by="['value']"
            :sort-desc="[true]"
          ></v-data-table>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>

    <v-card-text
      class="timelineCaseSlider"
      v-if="seriesThailandGraph[0]"
      v-show="toggle_type === 0"
    >
      <v-row>
        <v-col class="pr-4">
          <v-slider
            v-model="slider"
            class="align-center"
            :thumb-size="96"
            thumb-label="always"
            min="0"
            :max="sliderMax"
          >
            <template v-slot:thumb-label="{ value }">{{ seriesThailandGraph[0].data[value].x }}</template>
          </v-slider>
          <v-btn :color="'rgba(25, 118, 210, 1)'" dark depressed fab @click="toggleIsPlay">
            <v-icon large>{{ isPlaying ? 'mdi-pause' : 'mdi-play' }}</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>

    <!-- <v-card flat class="seleted-type-global" v-show="toggle_type === 1">
      <v-row align="center" justify="center">
        <v-btn-toggle v-model="toggle_type_case">
          <v-btn>
            <v-icon></v-icon>
            <div>ผู้ติดเชื้อ</div>
          </v-btn>
          <v-btn>
            <div>รักษาหาย</div>
          </v-btn>
          <v-btn>
            <div>เสียชีวิต</div>
          </v-btn>
        </v-btn-toggle>
      </v-row>
    </v-card> -->

    <div class="mobile-nav-bar" v-if="dataTimeline[0]">
        <span
          v-show="toggle_type === 0"
          style="font-size: 0.8em; color:rgb(191, 191, 191);"
        >{{ convertDate(dataTimeline[slider].Date) }}</span>
        <span
          v-show="toggle_type === 1 && worldCaseData !== undefined"
          style="font-size: 0.8em; color:rgb(191, 191, 191);"
        >{{ convertDateWorldData(worldCaseData.lastUpdated) }}</span>
    </div>

    <v-card flat dark style="position:absolute;top:0;right:0;background-color: unset;">
      <v-card-text style="padding-top: 8px;">
        <v-row align="center" justify="center">
          <v-bottom-navigation shaped dark v-model="toggle_type" color="#6baaf5 lighten-1">
            <v-btn>
              <div class="naviagate-text">ประเทศไทย</div>
              <img src="/flags/th.png" alt="" class="navigate-img">
            </v-btn>
            <v-btn>
              <div class="naviagate-text">โลก</div>
              <img src="/flags/world.png" alt="" class="navigate-img">
            </v-btn>
          </v-bottom-navigation>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import Vue from "vue";
import VueApexCharts from "vue-apexcharts";
import axios from "axios";
import VueAxios from "vue-axios";
import thailandLowWKT from "@/assets/thailandVector.json";
import worldWKT from "@/assets/world_boundary_data.json";
import moment from "moment";

require("moment/locale/th");
// import statsComponent from "@/components/Stats.vue";

Vue.use(require("vue-moment"), {
  moment
});
Vue.use(VueAxios, axios);
Vue.component("apexchart", VueApexCharts);

export default {
  name: "MapCovid",
  components: {},
  data: () => ({
    tabs: 0,
    status: {
      Recovered: "-",
      Deaths: "-",
      Hospitalized: "-",
      Confirmed: "-",
      NewRecovered: "-",
      NewConfirmed: "-",
      NewHospitalized: "-",
      NewDeaths: "-",
      UpdateDate: "-"
    },
    isPlaying: false,
    playInterval: undefined,
    dataTimeline: [],
    groupProvinceTimeline: {},
    thailandLowWKT: thailandLowWKT,
    worldWKT: worldWKT,
    thailandChartOptions: {
      chart: {
        background: "#1e1e1e",
        type: "line",
        id: "vuechart-example",
        group: "timeline",
        zoom: {
          enabled: true
        }
      },
      colors: ["#5EAAFF", "#FFC431", "#4BC09E", "#F14554"],
      // dataLabels: {
      //   enabled: true,
      //   labels: {}
      // },
      markers: {
        size: 0.3
      },
      xaxis: {
        type: "datetime",
        min: new Date().getTime() - 86400000 * 60,
        max: new Date().getTime() - 86400000
      },
      yaxis: {
        opposite: true
      },
      theme: {
        mode: "dark",
        palette: "palette1"
      }
    },
    seriesThailandGraph: [],
    provinceBarChartOptions: {
      chart: {
        type: "bar",
        height: 300,
        background: "#1e1e1e"
      },
      plotOptions: {
        bar: {
          dataLabels: {
            position: "bottom" // top, center, bottom
          }
        }
      },
      theme: {
        mode: "dark",
        palette: "palette1"
      },
      dataLabels: {
        enabled: false
      },
      xaxis: {
        categories: []
      }
    },
    provinceCaseSeries: [
      {
        name: "จำนวน",
        data: []
      }
    ],
    newCaseChartSeries: [
      {
        name: "ผู้ป่วยยืนยัน",
        data: []
      }
    ],
    newCaseChartOptions: {
      chart: {
        background: "#1e1e1e",
        type: "line",
        group: "timeline",
        zoom: {
          enabled: true
        }
      },
      markers: {
        size: 0.3
      },
      dataLabels: {
        enabled: true
      },
      stroke: {
        curve: "straight"
      },
      theme: {
        mode: "dark",
        palette: "palette1"
      },
      xaxis: {
        type: "datetime",
        min: new Date().getTime() - 86400000 * 30,
        max: new Date().getTime() - 86400000
      },
      yaxis: {
        opposite: true
      }
    },
    provinceTimelineHeader: [
      {
        text: "จังหวัด",
        align: "start",
        value: "name"
      },
      { text: "จำนวน", align: "end", sortable: true, value: "value" }
    ],
    provinceTimelineItems: [],
    worldTableHeaders: [
      {
        text: "",
        sortable: false,
        align: "end",
        value: "index"
      },
      {
        text: "ประเทศ",
        align: "start",
        sortable: false,
        value: "name"
      },
      { text: "ผู้ติดเชื้อ", align: "end", value: "confirmed" },
      { text: "รักษาหาย", align: "end", value: "recovered" },
      { text: "เสียชีวิต", align: "end", value: "deaths" }
    ],
    worldTableContent: [],
    worldCaseData: undefined,
    sortBy: "confirmed",
    sortDesc: true,
    slider: "0",
    sliderMax: "0",
    toggle_type: 1,
    toggle_type_case: 0,
    publicPath: process.env.BASE_URL,
    activeBtn: 1,
    columns: [
      {
        label: "ประเทศ",
        field: "name"
      },
      {
        label: "สะสม",
        field: "confirmed",
        type: "number"
      },
      {
        label: "หายแล้ว",
        field: "recovered",
        type: "number"
      },
      {
        label: "เสียชีวิต",
        field: "deaths",
        type: "number"
      }
    ],
    showNav: true
  }),
  computed: {
    buttonWorldList() {
      const self = this;
      return self.showNav ? "ซ่อน" : "เปิด";
    }
  },
  mounted() {
    const self = this;
    self.initMap();
    self.getGraphThailand();
    self.loadTodayData();
    self.loadTodayWorld();
    // self.updateFillColorPolygon();
    self.map.location({ lat: 13.241748, lon: 3.053266 });
    self.map.zoom(2);
    self.map.zoomRange({ min: 2, max: 6 });
  },
  methods: {
    initMap() {
      const self = this;
      self.map = new window.longdo.Map({
        placeholder: document.getElementById("map-full")
        // ui: window.longdo.UiComponent.Mobile
      });
      self.map.Ui.LayerSelector.visible(false);
      self.map.Ui.Zoombar.visible(false);
      self.map.Ui.Geolocation.visible(false);
      self.map.Ui.Fullscreen.visible(false);
      self.map.Ui.DPad.visible(false);
      self.map.Ui.Zoombar.visible(false);
      self.map.Ui.Geolocation.visible(false);
      self.map.Ui.Toolbar.visible(false);
      // self.map.location({ lat: 13.091983, lon: 94.151899 });
      // if (window.innerWidth < 600) {
      //   self.map.location({ lat: 13.220359, lon: 100.392133 });
      // }
      // self.map.zoom(6);
      // self.map.zoomRange({min: 3, max: 6})
      self.bindMapEvent();
      self.loadProvinceData();
    },
    bindMapEvent() {
      const self = this;
      self.map.Event.bind("overlayHover", obj => {
        if (obj instanceof window.longdo.Polygon) {
          self.isInSelectedPolygon = false;
          if (self.selectedPolygon) {
            self.selectedPolygon.ward.polygonList.forEach(p => {
              if (p === obj) {
                self.isInSelectedPolygon = true;
              }
            });
          }
          if (!self.isInSelectedPolygon) {
            obj.update({
              lineWidth: 1
            });
          }
          obj.pop();
        }
      });

      self.map.Event.bind("overlayLeave", obj => {
        if (obj instanceof window.longdo.Polygon) {
          self.isInSelectedPolygon = false;
          if (self.selectedPolygon) {
            self.selectedPolygon.ward.polygonList.forEach(p => {
              if (p === obj) {
                self.isInSelectedPolygon = true;
              }
            });
          }
          if (!self.isInSelectedPolygon) {
            obj.update({
              lineWidth: 1
            });
          }
        }
      });
    },
    loadTodayWorld() {
      const self = this;
      Vue.axios
        .get("https://covid19-cdn.workpointnews.com/api/world.json")
        .then(response => {
          self.worldCaseData = response.data;
          self.worldCaseData.statistics.forEach(x => {
            if (x.confirmed !== null) {
              self.worldTableContent.push({
                index: "",
                alpha2: x.alpha2,
                name: x.name,
                confirmed: x.confirmed,
                recovered: x.recovered,
                deaths: x.deaths,
              });
            }
          });
          self.makeWorldWKT();
        });
    },
    loadProvinceData() {
      let self = this;
      Vue.axios
        .get("https://covid19.th-stat.com/api/open/cases")
        .then(response => {
          let tempCovidProvince = {};

          response.data.Data.forEach(function(a) {
            tempCovidProvince[a.Province] =
              (tempCovidProvince[a.Province] || 0) + 1;
          });

          // let groupByAge = [];
          // groupByAge = response.data.Data.reduce((acc, it) => {
          //   acc[it.Province] = acc[it.Province] + 1 || 1;
          //   return acc;
          // }, {});
          // console.log(response.data.Data);
          // console.log(tempCovidProvince);
          // self.makeWKTPolygon(tempCovidProvince);
          self.makeRangeProvince(tempCovidProvince);
          self.checkDuplicateInObject("ConfirmDate", response.data.Data);
          // self.bindMapClickProvince();

          // if (
          //   self.groupProvinceTimeline[
          //     self.toTimestamp(
          //       self.seriesThailandGraph[0].data[self.sliderMax].x
          //     )
          //   ] !== undefined
          // ) {
          //   self.map.Overlays.clear();
          //   self.makeWKTPolygon(
          //     self.groupProvinceTimeline[
          //       self.toTimestamp(
          //         self.seriesThailandGraph[0].data[self.sliderMax].x
          //       )
          //     ]
          //   );
          // } else {
          //   self.map.Overlays.clear();
          //   self.makeWKTPolygon({});
          // }
        });
    },
    checkDuplicateInObject(propertyName, inputArray) {
      const self = this;
      let groupTimeLine = {};

      inputArray.forEach(function(item) {
        let itemPropertyName = self.toTimestamp(item["ConfirmDate"]);

        if (itemPropertyName in groupTimeLine) {
          if (item["Province"] in groupTimeLine[itemPropertyName]) {
            groupTimeLine[itemPropertyName][item["Province"]] += 1;
          } else {
            groupTimeLine[itemPropertyName][item["Province"]] = 1;
          }
        } else {
          groupTimeLine[itemPropertyName] = {};
          groupTimeLine[itemPropertyName][item["Province"]] = 1;
        }
      });
      self.groupProvinceTimeline = groupTimeLine;
    },
    makeWKTPolygon(params) {
      let self = this;
      let tempValue = "";
      self.tempFillColor = "rgba(255, 255, 255, 0.8)";
      self.thailandLowWKT.forEach(element => {
        for (let [key, value] of Object.entries(params)) {
          if (element.name_th === `${key}`) {
            self.tempFillColor = self.assignColor(Number(`${value}`));
            tempValue = `${value}`;
          }
        }

        element.polygonList = new window.longdo.Util.overlayFromWkt(
          element.WKT,
          {
            lineColor: "rgba(255, 255, 255, 0.8)",
            lineWidth: 1,
            fillColor: self.tempFillColor,
            clickable: true,
            title: element.name_th,
            label: tempValue
          }
        );
        tempValue = 0;

        element.polygonList.forEach(p => {
          self.map.Overlays.add(p);
        });
        self.tempFillColor = "rgba(255, 255, 255, 0.8)";
      });
    },
    makeWorldWKT() {
      let self = this;
      let tempValue = "";
      let tempContry = "";
      let tempColor = "rgba(255, 255, 255, 0.8)";
      if (self.toggle_type_case === undefined) {
        return 0;
      }
      self.map.Overlays.clear();
      self.worldWKT.forEach(element => {
        tempColor = "rgba(255, 255, 255, 0.8)";
        self.worldCaseData.statistics.forEach(x => {
          if (element.ISO2 === x.alpha2) {
            // console.log(x.alpha2 + x.confirmed)
            tempValue = x;
            if (self.toggle_type_case === 0) {
              tempColor = self.assignWorldColor(x.confirmed);
              // tempValue = self.numberWithCommas(Number(x.confirmed));
              self.sortBy = "confirmed";
            } else if (self.toggle_type_case === 1) {
              tempColor = self.assignWorldColorRecovered(x.recovered);
              // tempValue = self.numberWithCommas(Number(x.recovered));
              self.sortBy = "recovered";
            } else if (self.toggle_type_case === 2) {
              tempColor = self.assignWorldColor(x.deaths);
              // tempValue = self.numberWithCommas(Number(x.deaths));
              self.sortBy = "deaths";
            } else {
              console.log("something wrong");
            }
            tempContry = self.numberWithCommas(x.name);
          }
        });
        element.polygonList = new window.longdo.Util.overlayFromWkt(
          element.WKT,
          {
            lineColor: "rgba(255, 255, 255, 0.8)",
            fillColor: tempColor,
            lineWidth: 1,
            clickable: false,
            popup: {
              html: '<div class="popupPlace"><div style="display:flex;flex-direction:row;align-items: center;"><img class="flag-icon" src="' +
              self.publicPath +
              "./flags/" +
              element.ISO2.toLowerCase() +
              '.png"/><div style="font-weight: bold;font-size: 16px;">' +
              tempContry +
              "</div></div><div class='popupLine'></div><div style='display:flex;flex-direction:column;margin-top:10px;text-align: start; font-family: Prompt;'>" +
              "<div class='popupFont'><div style='font-weight:bold;'>ผู้ติดเชื้อ:&nbsp;</div>" +
              self.numberWithCommas(Number(tempValue.confirmed)) +
              "</div><div class='popupFont'><div style='font-weight:bold;'>หายแล้ว:&nbsp;</div> " +
              self.numberWithCommas(Number(tempValue.recovered)) +
              "</div><div class='popupFont'><div style='font-weight:bold;'>เสียชีวิต:&nbsp;</div> " +
              self.numberWithCommas(Number(tempValue.deaths)) +
              "</div></div></div><div class='popup-tip-container'><div class='popup-tip'></div></div>"
            },
            // detail:
            //   '<div style="display:flex;flex-direction:row;justify-content:center;align-items:center;"><img class="flag-icon" src="' +
            //   self.publicPath +
            //   "./flags/" +
            //   element.ISO2.toLowerCase() +
            //   '.png"/><div style="font-size:15px;font-weight: bold;">' +
            //   tempContry +
            //   "</div></div><div style='display:flex;flex-direction:column;margin-top:10px;text-align: start; font-family: Prompt;'><div>ผู้ติดเชื้อ: " +
            //   self.numberWithCommas(Number(tempValue.confirmed)) +
            //   "</div><div>หายแล้ว: " +
            //   self.numberWithCommas(Number(tempValue.recovered)) +
            //   "</div><div>เสียชีวิต: " +
            //   self.numberWithCommas(Number(tempValue.deaths)) +
            //   "</div></div>"
          }
        );
        tempValue = [];

        element.polygonList.forEach(p => {
          self.map.Overlays.add(p);
        });
      });
    },
    getGraphThailand() {
      const self = this;
      Vue.axios
        .get("https://covid19.th-stat.com/api/open/timeline")
        .then(response => {
          let tempDataSeries = [];
          tempDataSeries = [
            {
              name: "สะสม",
              data: []
            },
            {
              name: "รักษา",
              data: []
            },
            {
              name: "หาย",
              data: []
            },
            {
              name: "เสียชีวิต",
              data: []
            }
          ];
          self.seriesNewConfirmed = [
            {
              name: "ผู้ป่วยยืนยัน",
              data: []
            }
          ];
          response.data.Data.forEach(element => {
            self.newCaseChartSeries[0].data.push({
              x: element.Date,
              y: element.NewConfirmed
            });
            tempDataSeries[0].data.push({
              x: element.Date,
              y: element.Confirmed
            });
            tempDataSeries[1].data.push({
              x: element.Date,
              y: element.Hospitalized
            });

            tempDataSeries[2].data.push({
              x: element.Date,
              y: element.Recovered
            });
            tempDataSeries[3].data.push({
              x: element.Date,
              y: element.Deaths
            });
            self.dataTimeline.push(element);
          });
          self.seriesThailandGraph = tempDataSeries;
          self.sliderMax = tempDataSeries[0].data.length - 1;
          self.slider = tempDataSeries[0].data.length - 1;
        });
    },
    makeRangeProvince(params) {
      const self = this;
      // let tempProvinceCaseBeforeSort = []
      self.provinceBarChartOptions.xaxis.categories = [];
      self.provinceCaseSeries[0].data = [];

      for (let [key, value] of Object.entries(params)) {
        // tempProvinceCaseBeforeSort.push({
        //   x: `${key}`,
        //   y: Number(`${value}`)
        // });
        self.provinceBarChartOptions.xaxis.categories.push(`${key}`);
        self.provinceCaseSeries[0].data.push(Number(`${value}`));
      }

      self.provinceCaseSeries[0].data.sort(function(a, b) {
        return a.y > b.y;
      });
    },
    assignColor(numberCase) {
      if (numberCase < 10) {
        return "rgba(254,240,217,0.8)";
      } else if (numberCase < 20) {
        return "rgba(253,204,138, 0.8)";
      } else if (numberCase < 40) {
        return "rgba(252,141,89, 0.8)";
      } else if (numberCase < 120) {
        return "rgba(227,74,51, 0.8)";
      } else {
        return "rgba(179,0,0, 1)";
      }
    },
    assignWorldColor(numberCase) {
      if (numberCase === null) {
        return "rgba(255,255,255,0.8)";
      } else if (numberCase < 1000) {
        return "rgba(254,240,217,0.8)";
      } else if (numberCase < 10000) {
        return "rgba(253,204,138, 0.8)";
      } else if (numberCase < 100000) {
        return "rgba(252,141,89, 0.8)";
      } else if (numberCase < 1000000) {
        return "rgba(227,74,51, 0.8)";
      } else {
        return "rgba(179,0,0, 1)";
      }
    },
    assignWorldColorRecovered(numberCase) {
      if (numberCase === null) {
        return "rgba(255,255,255,0.8)";
      } else if (numberCase < 1000) {
        return "rgba(159, 217, 185, 0.8)";
      } else if (numberCase < 10000) {
        return "rgba(113, 189, 149, 0.8)";
      } else if (numberCase < 100000) {
        return "rgba(84, 171, 125, 0.8)";
      } else if (numberCase < 1000000) {
        return "rgba(48, 147, 94, 0.8)";
      } else {
        return "rgba(9, 124, 64, 1)";
      }
    },
    loadTodayData() {
      const self = this;
      // .get("https://covid19.th-stat.com/api/open/today")
      Vue.axios
        .get("https://covid19.th-stat.com/api/open/today")
        .then(response => {
          self.status.Recovered = self.numberWithCommas(
            response.data.Recovered
          );
          self.status.Deaths = self.numberWithCommas(response.data.Deaths);
          self.status.Confirmed = self.numberWithCommas(
            response.data.Confirmed
          );
          self.status.Hospitalized = self.numberWithCommas(
            response.data.Hospitalized
          );
          self.status.NewDeaths = self.adjustNewCase(response.data.NewDeaths);
          self.status.NewConfirmed = self.adjustNewCase(
            response.data.NewConfirmed
          );
          self.status.NewRecovered = self.adjustNewCase(
            response.data.NewRecovered
          );
          self.status.NewHospitalized = self.adjustNewCase(
            response.data.NewHospitalized
          );
        });
    },
    adjustNewCase(value) {
      const self = this;
      if (value > 0) {
        return "เพิ่ม " + self.numberWithCommas(value) + " ราย";
      } else if (value < 0) {
        return "ลดลง " + self.numberWithCommas(Math.abs(value)) + " ราย";
      } else {
        return "ไม่มีรายใหม่";
      }
    },
    numberWithCommas(x) {
      return x.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      // return x
    },
    // updateFillColorPolygon(updatedObjProvince) {
    //   const self = this
    //   console.log()
    // },
    clickCountryTable (params) {
      const self = this;
      self.worldWKT.forEach(x => {
        if(params === x.ISO2) {
          self.map.location({lat: x.LAT,lon: x.LON});
        }
      })
    },
    toTimestamp(strDate) {
      var datum = Date.parse(strDate);
      return datum / 1000;
    },
    toggleIsPlay() {
      const self = this;
      self.isPlaying = !self.isPlaying;
      if (self.isPlaying && self.slider === self.sliderMax) {
        // self.isPlaying = !self.isPlaying;
        self.slider = 0;
        self.playInterval = setInterval(() => {
          self.slider += 1;
        }, 300);
      } else if (self.isPlaying && self.slider !== self.sliderMax) {
        self.playInterval = setInterval(() => {
          self.slider += 1;
        }, 300);
      } else {
        clearInterval(self.playInterval);
      }
    },
    convertDate(date) {
      let tempDate = undefined;
      tempDate = moment(date, "MM/DD/YYYY HH:mm");
      return (
        "วัน" +
        tempDate.format("dddd") +
        "ที่ " +
        tempDate.format("Do ") +
        tempDate.format("MMMM ") +
        Number(tempDate.year() + 543)
      );
    },
    convertDateWorldData(date) {
      let tempDate = undefined;
      tempDate = moment(date, moment.ISO_8601);
      return (
        "วัน" +
        tempDate.format("dddd") +
        "ที่ " +
        tempDate.format("Do ") +
        tempDate.format("MMMM ") +
        Number(tempDate.year() + 543)
      );
    }
  },
  watch: {
    slider: function(value) {
      const self = this;
      if(self.toggle_type === 1) {
        return 0
      }
      let tempObjectProvince = {};
      if (!value) {
        self.map.Overlays.clear();
        self.makeWKTPolygon({ กรุงเทพมหานคร: 0 });
      } else {
        tempObjectProvince =
          self.groupProvinceTimeline[
            self.toTimestamp(self.seriesThailandGraph[0].data[self.slider].x)
          ];
        self.provinceTimelineItems = [];
        if (tempObjectProvince !== undefined) {
          for (let [key, value] of Object.entries(tempObjectProvince)) {
            self.provinceTimelineItems.push({ name: key, value: value });
          }
          self.map.Overlays.clear();
          self.makeWKTPolygon(tempObjectProvince);
          self.tabs = 2;
        } else {
          self.map.Overlays.clear();
          self.makeWKTPolygon({});
        }
      }
      if (value === self.sliderMax) {
        self.isPlaying = false;
        clearInterval(self.playInterval);
        // self.slider = 0;
      }
    },
    toggle_type: function(value, oldValue) {
      const self = this;
      if(value === undefined) {
        value = oldValue
      }
      if (value === 1) {
        self.map.Overlays.clear();
        self.makeWorldWKT();
        self.map.location({ lat: 13.241748, lon: 3.053266 });
        self.map.zoom(2);
        self.map.zoomRange({ min: 2, max: 6 });
      } else if (value === 0) {
        self.map.Overlays.clear();
        self.map.location({ lat: 13.091983, lon: 94.151899 });
        if (window.innerWidth < 600) {
          self.map.location({ lat: 13.220359, lon: 100.392133 });
        }
        self.map.zoom(6);
        self.map.zoomRange({ min: 2, max: 18 });
        if (
          self.groupProvinceTimeline[
            self.toTimestamp(self.seriesThailandGraph[0].data[self.sliderMax].x)
          ] !== undefined
        ) {
          self.map.Overlays.clear();
          self.makeWKTPolygon(
            self.groupProvinceTimeline[
              self.toTimestamp(
                self.seriesThailandGraph[0].data[self.sliderMax].x
              )
            ]
          );
        } else {
          self.map.Overlays.clear();
          self.makeWKTPolygon({});
        }
      } else {
        console.log("something wrong");
      }
    },
    toggle_type_case: function() {
      const self = this;
      self.makeWorldWKT();
    }
  }
};
</script>

<style scoped>
html {
  overflow-y: hidden;
}
.timelineCaseSlider {
  position: absolute;
  bottom: 0px;
  width: 40%;
  right: 50px;
}
.map-contanier {
  max-width: 100% !important;
  height: 100%;
}
#map-full {
  height: 100%;
}
.thailandChart {
  /* position: absolute;
  bottom: 0px;
  right: 5px;
  width: 700px; */
  /* background-color: unset; */
  width: 100%;
  max-height: 350px;
  overflow-y: scroll;
}
.title-area-container {
  /* background-color: black; */
}
.information-container {
  position: absolute;
  /* top: 0; */
  background-color: #1f1f1f;
  bottom: 4px;
  left: 4px;
  width: 50%;
  /* height: calc(100% - 320px); */
  /* min-height: 400px; */
}
.v-window-item .v-window-item--active {
}
.stats-card {
  position: absolute;
  top: 114px;
  width: 300px;
}
.title-card {
  position: absolute;
  top: 0px;
  width: 300px;
}
.report-header {
  color: #fff !important;
  width: 100%;
}
.report-number {
  font-size: 16px;
  display: block;
  padding: 5px;
}
.report-number-sub {
  font-size: 16px;
  padding: 5px;
}
.added-number-report {
  font-size: 10px;
}
.report-title {
  padding: 5px 10px;
  font-size: 12px;
}
.title-web {
  padding: 8px;
}
.world-table-reported {
  /* min-height: 300px;
  max-height: 350px; */
  height: calc(100% - 320px);
  bottom: 0px;
  margin-left: 10px;
  position: absolute;
  width: 500px;
  overflow-y: scroll;
}
.world-table-reported-mobile {
  display: none;
  min-height: 300px;
  max-height: 350px;
  bottom: 0px;
  position: absolute;
  width: 100%;
  overflow-y: scroll;
  font-size: 14px;
}
.flag-icon {
  width: 28px;
  min-width: 28px;
  height: 28px;
  margin-right: 16px;
  border: 1px solid #FFFFFF;
  background-color: rgb(239, 242, 247);
  object-fit: cover;
  box-shadow: rgba(0, 0, 0, 0.5) 0px 2px 5px;
  border-radius: 100%;
  overflow: hidden;
}
.pointer {
  cursor: pointer;
}
.seleted-type-global {
  position: absolute;
  bottom: 0;
  right: 40%;
  background-color: unset;
}
.hide-world-list,
.mobile-nav-bar {
  display: none;
}
.toggle-world-table {
  display: flex;
  position: absolute;
  bottom: calc(100% - 320px + 5px);
  margin-left: 10px;
}
.naviagate-text {
  padding-top: 6px;
}
.navigate-img {
  height: 16px;
}
@media only screen and (max-width: 600px) {
  .v-bottom-navigation {
    height: 30px !important;
  }
  .naviagate-text {
    padding: 0px;
  }
  .navigate-img {
    display: none;
  }
  .world-table-reported {
    max-height: 310px;
  }
  .mobile-nav-bar {
    display: flex;
    padding-left: 10px;
    align-items: center;
  }
  .hide-world-list {
    bottom: 360px;
    position: absolute;
    display: block;
    background-color: seashell;
  }
  .hide-world-list.active {
    bottom: 0px;
    position: absolute;
    display: block;
  }
  .v-tabs,
  .world-table-reported,
  .title-web {
    display: none;
  }
  .world-table-reported {
    display: block;
  }
  .toggle-world-table {
    display: block;
    position: absolute;
    bottom: 0px;
    width: 100px;
    height: 30px;
  }
  .toggle-world-table.active {
    position: absolute;
    bottom: 310px;
  }
  .toggle-world-table > button {
    width: 100%;
    height: 20px;
    border-bottom-right-radius: 0px;
    border-bottom-left-radius: 0px;
  }
  .world-table-reported {
    border-top-right-radius: 0px;
    border-top-left-radius: 0px;
  }
  .timelineCaseSlider {
    position: absolute;
    bottom: 0px;
    width: 80%;
    right: 40px;
  }
  .seleted-type-global {
    display: none;
  }
  .stats-card {
    position: absolute;
    width: fit-content;
    left: 0px;
    top: 50px;
  }
  .mobile-nav-bar {
    position: absolute;
    top: 0;
    height: 44px;
    background-color: #3c3c3c;
    width: 100%;
  }
  .button-selected-type {
    height: 30px !important;
  }
  .report-header {
    color: #fff !important;
  }
  .report-number {
    font-size: 18px;
    display: block;
  }
  .report-number-sub {
    font-size: 18px;
  }
  .report-title {
    padding: 6px;
    font-size: 10px;
  }
  .world-table-reported {
    margin-left: 0px;
  }
  .second-stats-card,
  .first-stats-card {
    flex-direction: column;
    max-width: 100px;
  }
  .report-header {
    width: 150px;
  }
}
</style>

<style>
.tr-country-table {
  cursor: pointer;
}
.ldmap_tile_offworld {
  background-color: #252525 !important;
}
.v-btn--active {
  background-color: black !important;
}
.world-table-reported > div > table > tbody > tr > .text-start {
  display: flex;
  align-items: center;
}
.flag-icon {
  width: 28px;
  height: 28px;
  margin-right: 16px;
  background-color: rgb(239, 242, 247);
  object-fit: cover;
  box-shadow: rgba(0, 0, 0, 0.5) 0px 2px 5px;
  border-radius: 100%;
  overflow: hidden;
}
#map-full img[src^="https://ms.simplethai.net"], img[src^="https://ms.longdo.com"] {
  filter: invert(1) hue-rotate(200deg) brightness(1) grayscale(1);
}
.thailandChart .apexcharts-canvas {
  /* background: #40404000; */
}
.ldmap_placeholder .ldmap_frame .ldmap_tile {
  background-color: #1b1b1b;
}
.v-slider__thumb-label {
  cursor: pointer;
}
html {
  overflow: hidden;
}
.v-item-group.v-bottom-navigation .v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  height: 100%;
}
</style>